import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';
import { from_links_to_string_predecessor } from '../../../assets/js/custom_gantt_fields/custom_predecessor';

const customPredecessorsCol = (gantt, t) => {
  const name = 'custom_predecessors';
  const isVisible = isColumnVisibleByDefault(name);

  return {
    name,
    label: t('gantt.columns.customPredecessors', 'Predecesoras'), // Translation
    width: '80',
    align: 'center',
    editor: { type: 'text', map_to: 'custom_predecessor' }, // Keep as is from original
    resize: true,
    template: function (activity) {
      const isOdd = gantt.oddColsConfig?.custom_predecessors || false;
      try {
        const hasChild = gantt.hasChild(activity.id);
        return (
          '<div class="' +
          (isOdd ? 'odd-col' : 'non-odd-col') +
          '" style="' +
          (hasChild ? 'font-weight: 600' : 'font-weight: 100') +
          '">' +
          from_links_to_string_predecessor(gantt)(activity) +
          '</div>'
        );
      } catch (e) {}
    },
    hide: !isVisible,
    data_type: 'string',
    // groupable, orderable, filterable properties were not in the original definition for this column
  };
};

export default customPredecessorsCol; 